/* GENERATED FILE */
import type { ReactElement, FC } from 'react';
import { Path } from 'react-native-svg';
import { type IconWeight } from '../lib';

export default new Map<
  IconWeight,
  ReactElement | FC<{ duotoneColor?: string; duotoneOpacity?: number }>
>([
  [
    'bold',
    <>
      <Path d="M160 80a16 16 0 1 1 16 16 16 16 0 0 1-16-16m72-36v168a20 20 0 0 1-20 20H44a20 20 0 0 1-20-20V44a20 20 0 0 1 20-20h168a20 20 0 0 1 20 20m-24 4H48v160h160Zm-68.49 75.51-16 16a12 12 0 0 0 17 17l16-16a12 12 0 1 0-17-17m-15-16a12 12 0 0 0-17 0l-8 8a12 12 0 0 0 17 17l8-8a12 12 0 0 0-.02-17ZM128 196a68.05 68.05 0 0 0 67.19-78.52 12 12 0 0 0-23.72 3.69 44 44 0 1 1-36.64-36.64 12 12 0 0 0 3.69-23.72A68 68 0 1 0 128 196" />
    </>,
  ],
  [
    'duotone',
    ({
      duotoneColor,
      duotoneOpacity,
    }: {
      duotoneColor?: string;
      duotoneOpacity?: number;
    }) => (
      <>
        <Path
          d="M184 128a56 56 0 1 1-56-56 56 56 0 0 1 56 56"
          opacity={duotoneOpacity}
          fill={duotoneColor}
        />
        <Path d="M208 32H48a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16m0 176H48V48h160zM128 64a64 64 0 1 0 64 64 64.07 64.07 0 0 0-64-64m0 112a48 48 0 1 1 48-48 48.05 48.05 0 0 1-48 48m72-108a12 12 0 1 1-12-12 12 12 0 0 1 12 12m-74.34 49.66-16 16a8 8 0 0 1-11.32-11.32l16-16a8 8 0 0 1 11.32 11.32m32-3.32a8 8 0 0 1 0 11.32l-32 32a8 8 0 0 1-11.32-11.32l32-32a8 8 0 0 1 11.32 0" />
      </>
    ),
  ],
  [
    'fill',
    <>
      <Path d="M208 32H48a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16m-80 152a56 56 0 1 1 56-56 56 56 0 0 1-56 56m60-104a12 12 0 1 1 12-12 12 12 0 0 1-12 12m-54.34 29.66-32 32a8 8 0 0 1-11.32-11.32l32-32a8 8 0 0 1 11.32 11.32m32-3.32a8 8 0 0 1 0 11.32l-48 48a8 8 0 0 1-11.32-11.32l48-48a8 8 0 0 1 11.32 0" />
    </>,
  ],
  [
    'light',
    <>
      <Path d="M208 34H48a14 14 0 0 0-14 14v160a14 14 0 0 0 14 14h160a14 14 0 0 0 14-14V48a14 14 0 0 0-14-14m2 174a2 2 0 0 1-2 2H48a2 2 0 0 1-2-2V48a2 2 0 0 1 2-2h160a2 2 0 0 1 2 2ZM128 66a62 62 0 1 0 62 62 62.07 62.07 0 0 0-62-62m0 112a50 50 0 1 1 50-50 50.06 50.06 0 0 1-50 50m70-110a10 10 0 1 1-10-10 10 10 0 0 1 10 10m-73.76 48.24-16 16a6 6 0 0 1-8.48-8.48l16-16a6 6 0 0 1 8.48 8.48m32-.48a6 6 0 0 1 0 8.48l-32 32a6 6 0 0 1-8.48-8.48l32-32a6 6 0 0 1 8.48 0" />
    </>,
  ],
  [
    'regular',
    <>
      <Path d="M208 32H48a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16m0 176H48V48h160zM128 64a64 64 0 1 0 64 64 64.07 64.07 0 0 0-64-64m0 112a48 48 0 1 1 48-48 48.05 48.05 0 0 1-48 48m72-108a12 12 0 1 1-12-12 12 12 0 0 1 12 12m-74.34 49.66-16 16a8 8 0 0 1-11.32-11.32l16-16a8 8 0 0 1 11.32 11.32m32-3.32a8 8 0 0 1 0 11.32l-32 32a8 8 0 0 1-11.32-11.32l32-32a8 8 0 0 1 11.32 0" />
    </>,
  ],
  [
    'thin',
    <>
      <Path d="M208 36H48a12 12 0 0 0-12 12v160a12 12 0 0 0 12 12h160a12 12 0 0 0 12-12V48a12 12 0 0 0-12-12m4 172a4 4 0 0 1-4 4H48a4 4 0 0 1-4-4V48a4 4 0 0 1 4-4h160a4 4 0 0 1 4 4ZM128 68a60 60 0 1 0 60 60 60.07 60.07 0 0 0-60-60m0 112a52 52 0 1 1 52-52 52.06 52.06 0 0 1-52 52m68-112a8 8 0 1 1-8-8 8 8 0 0 1 8 8m-73.17 46.83-16 16a4 4 0 0 1-5.66-5.66l16-16a4 4 0 0 1 5.66 5.66m32 2.34a4 4 0 0 1 0 5.66l-32 32a4 4 0 0 1-5.66-5.66l32-32a4 4 0 0 1 5.66 0" />
    </>,
  ],
]);
